import { FC, ReactNode } from 'react'
import { ProgramCard, ProgramCardType } from './Card'
import { ProgramPasscodeTag, ProgramPasscodeTagType } from './PasscodeTag'
import { ProgramTag, ProgramTagType } from './Tag'
import { ProgramVideo, ProgramVideoType } from './Video'

const Program: FC &
  ProgramTagType &
  ProgramCardType &
  ProgramPasscodeTagType &
  ProgramVideoType = (): ReactNode => <></>

Program.Tag = ProgramTag
Program.Card = ProgramCard
Program.PasscodeTag = ProgramPasscodeTag
Program.Video = ProgramVideo

export default Program
